<template>
  <b-modal
    v-if="tracks != null"
    ref="modal"
    centered
    :visible="tracks.length > 0"
    @hidden="cancelModal"
    modal-class="modal-condensed"
  >
    <template slot="modal-header">
      <!--      <h1>{{ Translations.sections.tracks.edition.targets }}</h1>-->
      <h1>Targets</h1>
      <div>
        <Button
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateTracks">Done</Button>
      </div>
    </template>
    <template>
      <div class="flex-container">
        <div class="form-container search">
          <input
            v-focus
            type="text"
            maxlength="100"
            placeholder="Search Target"
            v-model="searchData.searchTerm"
          />
        </div>
        <div class="search-result">
          <WaitingBlock v-if="modalState.isLoadingTargets"></WaitingBlock>
          <template v-else-if="searchResult != null && searchResult.dataItem != null && searchResult.dataItem.length > 0 && filteredTargets.length > 0" >
            <div v-for="target in filteredTargets" :key="target.id" style="margin-left: 15px; margin-top: 5px">
              <div @click.prevent="toggleTarget(target)"  >
                <i :class="['far', selectedTargets[target.id] === undefined ? 'fa-square':'fa-check-square']" ></i>
                <span class="name">{{target.name}}</span>
              </div>
            </div>
          </template>
          <div v-else class="no-result-container">
            <header>
              <strong>No target matching your search criteria</strong>
            </header>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="selection-container">
        <template v-if="selectedTargetsData.length>0">
          <header>{{selectedTargetsData.length}} selected targets :</header>
          <section>
            <div
              v-for="target in selectedTargetsData.targets"
              :key="target.id"
              :class="['badge', 'target-badge',{'selected' : selectedTargets[target.id] === undefined}]"
            >
              <span class="name">{{target.name}}</span>
              <span class="selector">
                <i class="fas fa-trash" @click.prevent="toggleTarget(target)"></i>
              </span>
            </div>
          </section>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Vue from "vue";
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "SelectorTargets",
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    Translations: () => Translations,
    trackUids() {
      return this.tracks.map(track => track.uid);
    },
    selectedTargetsData() {
      return {
        length: Object.keys(this.selectedTargets).length,
        targets: Object.values(this.selectedTargets).sort(function(a, b) {
          return a.displayOrder - b.displayOrder;
        })
      };
    },
    filteredTargets() {
      var str = (this.searchData.searchTerm || "").trim();
      if (str == null || str == "") return this.searchResult.dataItem || [];
      str = this.normalizeSearchTerm(str);
      str = this.normalizeSearchTerm(str);
      return this.searchResult.dataItem.filter(target => {
        return target.name.toLowerCase().includes(str.toLowerCase())
      })
    }
  },
  mounted() {
    this.search();
    // Set search input autofocus
  },
  directives: {
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function(el) {
        // hack to trigger inside method
        setTimeout(() => {
          el.focus();
        }, 0);
      }
    }
  },
  props: {
    stationUid: { required: true },
    multiselect: { required: false, default: true },
    noModalEdit: null,
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalState: {
        hasSearchProcessed: false,
        isLoadingTargets: false,
        delayedSearch: null
      },
      tracks: [],
      selectedTargets: {},
      searchResult: null,
      searchData: {
        searchTerm: "",
        pageSize: 50,
        page: 1
      },
      reducedTargets: []
    };
  },
  methods: {
    normalizeSearchTerm(str) {
      return (str || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // ------------------------------------------------------
    /* Start : Common Behaviour */
    // ------------------------------------------------------
    show() {
      this.$refs.modal.show();
    },
    edit(targets) {
      this.selectedTargets = targets && targets.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});

      this.show();
    },
    editForTracks(tracks) {
      var tmpTargets = {};
      this.tracks = tracks;
      if (this.tracks.length === 1) {
        for (var i = 0; i < (this.tracks[0].targets || []).length; i++) {
          tmpTargets[this.tracks[0].targets[i].id] = this.tracks[0].targets[i];
        }
      }

      this.selectedTargets = tmpTargets;
      this.show();
    },
    searchDelay(delay) {
      if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
      this.delayedSearch = setTimeout(this.search, delay || 150);
    },
    search() {
      this.modalState.isLoadingTargets = true;

      try {
        HTTP.get(Apis.parameters.targets)
          .then(this.searchEnd)
          .catch(this.searchError)
          .then(this.searchCompleted);
      } catch (e) {
        console.log(e);
      }
    },
    searchEnd(response) {
      this.searchResult = response.data;
      // console.log('search result :', this.searchResult);
    },
    searchError(response) {
      this.searchResult = response.data;
    },
    searchCompleted(response) {
      this.modalState.isLoadingTargets = false;
      this.modalState.hasSearchProcessed = true;
    },
    cancelModal() {
      this.modalState.hasSearchProcessed = true;
      this.searchData.searchTerm = "";
      this.$emit("onHidden");
      this.$refs["modal"].hide();
    },
    // ------------------------------------------------------
    /* End : Common Behaviour */
    // ------------------------------------------------------
    async updateTracks() {
        this.cancelModal();
        this.$emit("newValueTargets", "targets", this.selectedTargetsData.targets);
        return;

    },
    toggleTarget(target) {
      // console.log(target);
      target.isSelected = !target.isSelected;

      if (this.selectedTargets[target.id] != null) {
        Vue.delete(this.selectedTargets, target.id);
      } else {
        if (!this.multiselect) {
          this.selectedTargets = {};
        }

        const newTarget = target;
        const { id } = target;
        newTarget.displayOrder = new Date().getTime();

        this.selectedTargets = { ...this.selectedTargets, [target.id]: target };

        // this.$set(
        //   this.selectedTargets,
        //   target.id,
        //   Object.assign({ displayOrder: new Date().getTime() }, target)
        // );
      }

      // console.log('selected targets :', this.selectedTargets);
    },
    toggleReducedTargets(id) {
      // if targetd id already in toggleList, remove it

      const isReduced =
        this.reducedTargets && this.reducedTargets.find(el => el === id);

      if (isReduced) {
        this.reducedTargets = [...this.reducedTargets].filter(el => el !== id);
        return;
      }

      this.reducedTargets = [...this.reducedTargets, id];
    },
    isTargetReduced(id) {
      return this.reducedTargets && this.reducedTargets.includes(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.target-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;

  &.--child {
    margin-left: 10px;
    cursor: pointer;
  }
}

.no-result-container header {
  padding: 20px 25px;
}

.name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 1em;
}

.selector i,
.visible i {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.form-container {
  padding: 10px 25px;
  background: white;
}

.form-container.search {
  box-shadow: 0 5px 5px -5px #d2d2d2;
  position: sticky;
  top: 0px;
}

.search-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}

.far.fa-eye {
  color: white;
}

.far.fa-eye-slash {
  color: #ff2213;
}

.search-result {
  height: 400px;
  overflow: auto;
  max-height: 400px;
  overflow: auto;
}
</style>
